import React from 'react';
import { useTranslation } from 'react-i18next';
import { TestQuestionChart } from '@/components/LessonDetailsModal/TestQuestionChart';
import { MathText } from '@/components/MathText';
import { DETAILS_CARD } from '@/components/LessonDetailsModal/classNames';
import type { TestQuestion } from '@/types/testReport';

interface Props {
  question: TestQuestion;
  hasSubscription: boolean;
}

export const TestQuestionCard: React.FC<Props> = ({
  question,
  hasSubscription,
}) => {
  const { t } = useTranslation();

  const {
    orderNumber,
    questionText,
    pointsOfStudent,
    classAveragePoints,
    maxPoints,
    chartItems,
  } = question;
  const title = `${orderNumber}. ${questionText || t('diary.testReport.task')}`;
  const hasChart = hasSubscription && chartItems.length > 0;

  return (
    <div className={`flex flex-col ${DETAILS_CARD}`}>
      <MathText
        text={title}
        className="text-subhead-14 text-muted-foreground"
      />

      <div className="my-3 h-px bg-divider" />

      <div className="flex flex-col gap-3">
        <div className="text-subhead-14 flex justify-between gap-3 text-foreground">
          <span>{t('diary.testReport.studentPoints')}</span>
          <span>{pointsOfStudent}</span>
        </div>
        {hasSubscription && (
          <div className="text-body-14 flex justify-between gap-3 text-muted-foreground">
            <span>{t('diary.testReport.classAverage')}</span>
            <span>{classAveragePoints}</span>
          </div>
        )}
        <div className="text-body-14 flex justify-between gap-3 text-muted-foreground">
          <span>{t('diary.testReport.maxPoints')}</span>
          <span>{maxPoints}</span>
        </div>
      </div>

      {hasChart && (
        <>
          <div className="my-3 h-px bg-divider" />
          <TestQuestionChart items={chartItems} />
        </>
      )}
    </div>
  );
};
